import { useState } from "react";
import { useUiStyles, useModuleBEM } from "@b2bportal/core-themes";
import { CoreUiComponents } from "@b2bportal/core-types";
import clsx from "clsx";

import defaultStyles from "./AirlineIcon.module.scss";
import placeholderIconImage from "./placeholder-icon.png";

const CDN_BASE_URL = "https://cdn.hopper.com/airline_icons/";

export interface AirlineIconProps {
  // An airline code must consist of two uppercase letters or digits
  airlineCode: string;
  size?: AirlineIconSize;
  className?: string;
  altText?: string;
  config?: {
    cdnUrl?: string;
  };
}

export type AirlineIconSize = "small" | "medium" | "large";

/**
 * Load airline icon from remote hopper cdn, which is managed and up to date.
 * https://hopper-jira.atlassian.net/wiki/spaces/B2BTP/pages/6276513811/Hopper.com+CDN+usage
 * There is one size only on cdn. But since Airline icons are and backed by CDN, it shouldn't be a problem.
 */
export const AirlineIcon = (props: AirlineIconProps) => {
  const { size = "large", className, airlineCode, altText, config } = props;

  const cdnUrl = config?.cdnUrl ?? CDN_BASE_URL;

  const [block] = useModuleBEM(
    useUiStyles(CoreUiComponents.AirlineIcon, defaultStyles),
    CoreUiComponents.AirlineIcon,
    [size]
  );

  const [erroredCode, setErroredCode] = useState<string | null>(null);

  const iconUrl =
    !airlineCode || erroredCode === airlineCode
      ? placeholderIconImage
      : `${cdnUrl}${airlineCode}.png`;

  return (
    <div className={clsx(block, className)}>
      <img
        alt={altText ?? "airline icon"}
        src={iconUrl}
        onError={() => setErroredCode(airlineCode)}
      />
    </div>
  );
};
